import { __assign } from "tslib";
import { parseSelectionSet } from '@graphql-tools/utils';
import { Kind } from 'graphql';
export var forwardArgsToSelectionSet = function (selectionSet, mapping) {
    var selectionSetDef = parseSelectionSet(selectionSet, { noLocation: true });
    return function (field) {
        var selections = selectionSetDef.selections.map(function (selectionNode) {
            if (selectionNode.kind === Kind.FIELD) {
                if (!mapping) {
                    return __assign(__assign({}, selectionNode), { arguments: field.arguments.slice() });
                }
                else if (selectionNode.name.value in mapping) {
                    var selectionArgs_1 = mapping[selectionNode.name.value];
                    return __assign(__assign({}, selectionNode), { arguments: field.arguments.filter(function (arg) { return selectionArgs_1.includes(arg.name.value); }) });
                }
            }
            return selectionNode;
        });
        return __assign(__assign({}, selectionSetDef), { selections: selections });
    };
};
//# sourceMappingURL=selectionSetArgs.js.map